import {z} from 'zod'

export const DocumentSchema = z.object({
    id: z.number(),
    file_name: z.string(),
    file_size_in_mb: z.number(),
    pages_count: z.number(),
    mime_type: z.string(),
    created_at: z.string(),
    updated_at: z.string()
})
export const ChatFileSchema = z.object({
    id: z.number(),
    sender_id: z.number(),
    receiver_id: z.number(),
    type: z.string(),
    path_location: z.string(),
    blurred_path_location: z.string().nullable(),
    title: z.string().nullable(),
    morgi: z.number().nullable(),
    representative_id: z.number().nullable(),
    representative_first_name: z.string().nullable(),
    url: z.string(),
    blurred_url: z.string().nullable(),
    paid_users: z.array(z.number()),
    group_key_name: z.string().nullable(),
    message: z.string().nullable().optional(),
    document_id: z.number().nullable(),
    document: DocumentSchema.nullable()
})

export const LastReadsTimetokensSchema = z.object({
    id: z.number(),
    user_id: z.number(),
    channel_id: z.number(),
    timetoken: z.string(),
    representative_id: z.number().nullable(),
    created_at: z.string(),
    updated_at: z.string()
})

export const AnimationSchema = z.object({
    id: z.number(),
    url: z.string(),
    key_name: z.string(),
    name: z.string(),
    amount: z.number()
})

export const ChatReportCategoriesSchema = z.object({
    id: z.number(),
    key_name: z.string(),
    name: z.string(),
    created_at: z.string(),
    updated_at: z.string()
})
